<div class="cmps-cdk-d-flex">
    <ng-container *ngIf="_state.phase?.live !== true">
        <div>
            <button
                type="button"
                class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-border-radius-4px cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-min-h-24p cmps-cdk-px-0dot75 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center focus:not:focus-visible:cmps-cdk-outline-0 cmps-cdk-bg-color-white cmps-cdk-border-color-unknown-107 cmps-cdk-color-unknown-122 hover:cmps-cdk-bg-color-unknown-103 hover:cmps-cdk-border-color-unknown-105 hover:cmps-cdk-color-unknown-104"
                (click)="$event.stopPropagation(); _onAddMyFocusClick()"
            >
                <cmps-icon
                    class="cmps-cdk-w-16px nested:cmps-cdk-w-inherit"
                    svgIcon="plus"
                ></cmps-icon>
                <span class="cmps-cdk-line-clamp-1">Add my Focus</span>
            </button>
        </div>
    </ng-container>
</div>
